import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Button,
    Container,
    Grid, Skeleton,
    Stack,
    Chip,
    Modal,
    useMediaQuery,
} from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../styles/productDetailCard.css";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { isDiscountedProduct } from "../../../hooks/utilsFn/utilsFn";
import { useSelector } from "react-redux";
import { HOLILEFTBOYICON, HOLIRIGHTBOYICON } from "../../../imports/generalImport";

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 999,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    width: {
        xs: "90%",
        sm: "80%",
        xl: "100%"
    },
    maxWidth: 'lg',
    borderRadius: { xs: 2 }
};

const ProductDetailCard = ({ pageLoading}) => {
    const PRODUCTDETAILS = useSelector((state) => state?.ProductDetail?.allData);
    const [open, setOpen] = React.useState(false);
    const [characterNo, setCharacterNo] = useState(540);
    const lgDevices = useMediaQuery("(min-width:900px)");

    useEffect(() => {
        if (!lgDevices) {
            setCharacterNo(260);
        } else {
            setCharacterNo(540);
        }
    }, [lgDevices]);


    function handleShowMore(description) {
        if (description?.length > characterNo) {
            return description.slice(0, characterNo - 3) + '......';
        }
        return description;
    }


    const settings = {
        dots: false,
        lazyLoad: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
    };

    const productDiscount = (discountKey, discount) => {
        return <Chip label={`${discountKey || "Discount"} : ${discount}%`}
            sx={{
                fontSize: { xs: ".7rem", sm: "1rem" },
                fontWeight: 500,
                color: "white.main",
                backgroundColor: "primary.main"
            }}
        />
    }   

    const isStoreRedeem = (redeem) => {
        if (redeem) {
            return < Chip key={'storeTrue'} icon={<CheckCircleIcon sx={{
                color: "#2ab638 !important"
            }}
            />} label="Store" variant="filled" sx={{
                color: "#0fab22",
                backgroundColor: "#caf6be",
                fontSize: { lg: "1rem" },
                fontWeight: { lg: 500 },
            }} />
        } else {
            return < Chip icon={<CancelIcon sx={{
                color: "#ea0c0c !important"
            }} />}
                label="Store" variant="filled" sx={{
                    color: "#ff2121",
                    backgroundColor: "#f6bebe",
                    fontSize: { lg: "1rem" },
                    fontWeight: { lg: 500 },
                }} />
        }
    }

    const isOnlineRedeem = (redeem) => {

        if (redeem) {
            return < Chip icon={<CheckCircleIcon sx={{
                color: "#2ab638 !important"
            }}
            />} label="Online" variant="filled" sx={{
                color: "#0fab22",
                backgroundColor: "#caf6be",
                fontSize: { lg: "1rem" },
                fontWeight: { lg: 500 },
            }} />
        }
        else {
            return < Chip icon={<CancelIcon sx={{
                color: "#ea0c0c !important"
            }} />} label="Online" variant="filled" sx={{
                color: "#ff2121",
                backgroundColor: "#f6bebe",
                fontSize: { lg: "1rem" },
                fontWeight: { lg: 500 },
            }} />
        }
    }

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <Container
            maxWidth="xl"
            className="product_detail_mcontainer"
            sx={{
                px: { xs: 1, sm: 0 },
                backgroundColor: 'transparent',
            }}
        >
            <Grid
                container
                sx={{
                    justifyContent: { xs: "flex-start", sm: 'center'},
                    minHeight: { xs: "230px", sm: "240px", lg: 170 },
                    pt: { xs: 0, sm: 3, md: 2, lg: 2 },
                    pb: { xs: 0, sm: "1.5rem", lg: 0 },
                    px: { xs: 0, sm: "1.5rem" },
                }}
            >

                <Grid item xs={12} md={5} lg={5}
                    sx={{
                        px: { xs: 1, },
                        mb: { xs: 3, lg: 0 },
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Box sx={{
                        width: "100%",
                        maxWidth: "300px",
                        position:"relative",
                    }}>
                        {!pageLoading ?
                            <Slider {...settings} arrows={true} >
                                {/* {productDetail?.Product_Sliders} */}
                                {PRODUCTDETAILS?.Product_Sliders?.length > 0 ?
                                    (PRODUCTDETAILS?.Product_Sliders?.map((item) => (
                                        <Box
                                            key={`product-details-${item?.id * 1}`}
                                            sx={{
                                                minWidth: "280px",
                                                height: { xs: "180px", sm: "200px", lg: "200px" },
                                                overflow: { xs: "hidden" },
                                                display: { xs: "flex" },
                                                alignItems: { xs: "center" },
                                                justifyContent: { xs: "center" },
                                                zIndex: 9
                                            }}
                                        >
                                            <Box
                                                component="img"
                                                src={item?.img}
                                                alt={item?.title}
                                                sx={{
                                                    width: "100%",
                                                    height: { xs: "180px", sm: "200px", lg: "200px" },
                                                    objectFit: { xs: "contain", sm: "contain" },
                                                    borderRadius: { xs: 1, sm: 2 },
                                                    border : "1px dashed red",
                                                    zIndex: 9
                                                }}
                                            />
                                        </Box>
                                    )))
                                    :
                                    ([0, 1, 2, 3, 4, 5].map((_, item) => (
                                        <Box
                                            key={`product-details-${item * 1}`}
                                            sx={{
                                                minWidth: "280px",
                                                height: { xs: "180px", sm: "200px", lg: "200px" },
                                                overflow: { xs: "hidden" },
                                                display: { xs: "flex" },
                                                alignItems: { xs: "center" },
                                                justifyContent: { xs: "center" },
                                                zIndex: 9
                                            }}
                                        >
                                            <Box
                                                component="img"
                                                src={PRODUCTDETAILS?.image}
                                                alt={PRODUCTDETAILS?.title}
                                                sx={{
                                                    width: "100%",
                                                    height: { xs: "180px", sm: "200px", lg: "200px" },
                                                    objectFit: { xs: "contain", sm: "contain" },
                                                    borderRadius: { xs: 1, sm: 2 },
                                                    zIndex: 9
                                                }}
                                            />

                                        </Box>
                                    )))
                                }
                            </Slider>
                            :
                            <Skeleton variant="rounded" animation="wave" width="100%" height="280px" />
                        }
                    </Box>
                </Grid>

                <Grid item xs={12} md={7} lg={7}
                    sx={{
                        pt: { xs: "5px", sm: 1, lg: 1 },
                        pb: { xs: "5px", sm: "20px", lg: 1 },
                        px: { xs: "10px", sm: "20px" },
                    }}
                >
                    <Box>
                        {!pageLoading ? (
                            <Typography
                                variant="h1"
                                gutterBottom
                                sx={{
                                    fontSize: { sm: "1.5rem", lg: "1.5rem" },
                                    color: "primary.main",
                                    fontWeight: 500,
                                    textAlign: {sm: 'center', md: "left" },
                                }}
                            >
                                {PRODUCTDETAILS?.title}
                            </Typography>
                        ) : (
                            <Skeleton
                                variant="text"
                                animation="wave"
                                sx={{ fontSize: "2rem", color: "primary.main", fontWeight: 400 }}
                            />
                        )}

                        {!pageLoading ? (
                            <Stack
                                direction="row"
                                spacing={1}
                                sx={{
                                    mt: { xs: 2, sm: 2, lg: 1 },
                                    py: { lg: "4px" },
                                    justifyContent: {sm: 'center',  md: "flex-start"},
                                }}
                            >
                                {PRODUCTDETAILS && productDiscount(PRODUCTDETAILS.productType,PRODUCTDETAILS.discount)}
                                {PRODUCTDETAILS && isStoreRedeem(PRODUCTDETAILS?.store)}
                                {PRODUCTDETAILS && isOnlineRedeem(PRODUCTDETAILS?.website)}
                            </Stack>
                        ) : (
                            <Skeleton variant="text" animation="wave" sx={{ width: "100%", height: "60px" }} />
                        )}

                        {!pageLoading ? (
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    color: "textPrimary.main",
                                    fontSize: { sm: "1.1rem", lg: "1.2rem" },
                                    fontWeight: 400,
                                    mt: { xs: 2, sm: 2, lg: 1 },
                                    mb: { xs: 1, lg: "1rem" },
                                }}
                            >
                                {handleShowMore(PRODUCTDETAILS?.description)}
                            </Typography>
                        ) : (
                            <Skeleton variant="text" animation="wave" sx={{ width: "100%", height: "30px" }} />
                        )}

                        {(PRODUCTDETAILS?.description?.length > characterNo) && (
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: {
                                        xs: "flex-start",
                                        sm: 'flex-end',
                                        md: "flex-start",
                                    },
                                    alignItems: "center",
                                }}
                            >
                                <Button
                                    variant="contained"
                                    size="medium"
                                    onClick={handleOpen}
                                    sx={{
                                        mt: { xs: 0, sm: 1, lg: 0 },
                                        mb: { xs: 0, lg: 1 },
                                    }}
                                >
                                    Details
                                </Button>
                            </Box>
                        )}

                    </Box>
                </Grid>
            </Grid>

            {/* Details Modal */}
            <Modal open={open} onClose={handleClose}>
                <Box sx={modalStyle}>
                    <Typography variant="h6" component="h2">
                        {PRODUCTDETAILS?.title}
                    </Typography>
                    <Typography sx={{ mt: 2 }}>{PRODUCTDETAILS?.description}</Typography>
                    <Button variant="contained" onClick={handleClose} sx={{ mt: 3 }}>
                        Close
                    </Button>
                </Box>
            </Modal>

        </Container>
    );
};

export default ProductDetailCard;
